import { useMemo } from "react";
import { getFileUploadName } from "src/utils/common";
import { useTranslation } from "react-i18next";
import {
  ERROR_CODE_BY_TYPE,
  SUB_TEXT_BY_ERROR_TYPE,
} from "src/constant/common";

// Pure function to process error details
export const getErrorDetails = (errList, fileName, t) => {
  const getFieldFromErrorData = (errFields = []) => {
    let fields = errFields.filter(
      (item) => !String(item).includes("list[") && !String(item).includes("literal[")
    );
    if (fields.some((field) => Number.isInteger(field))) {
      fields = fields
        .map((field) => (Number.isInteger(field) ? `[${field}]` : field))
        .join(".");
      fields = fields.replace(/\.\[/g, "[");
    } else {
      fields = fields.join(".");
    }
    return fields;
  };

  if (!errList?.length) {
    return [];
  }

  let outputList = [];
  const groupByErrorCode = {};
  for (const errItem of errList) {
    const errCode = ERROR_CODE_BY_TYPE?.[errItem.type] || "FE-0005";
    groupByErrorCode[errCode] = groupByErrorCode?.[errCode] || { [errItem.type]: [] };
    groupByErrorCode[errCode][errItem.type] = groupByErrorCode?.[errCode]?.[errItem.type] || [];
    groupByErrorCode[errCode][errItem.type].push(errItem);
  }

  for (const errCode in groupByErrorCode) {
    let errMsgItem = "• " + t(`error.${errCode}-title`);
    const errGroup = groupByErrorCode[errCode];

    switch (errCode) {
      case "FE-0007":
        for (const type in errGroup) {
          for (const errItem of errGroup[type]) {
            const fieldName1 = getFieldFromErrorData(errItem?.fields?.[0]);
            const fieldName2 = getFieldFromErrorData(errItem?.fields?.[1]);
            errMsgItem += t(`error.${errCode}-content`, {
              field_name_1: fieldName1,
              field_name_2: fieldName2,
              file_name: getFileUploadName(fileName),
            });
          }
        }
        break;
      default:
        for (const type in errGroup) {
          const fields = [
            ...new Set(errGroup[type].map((item) => getFieldFromErrorData(item.loc))),
          ].join(", ");
          const descMsg = errGroup[type][0]?.msg || "";
          const min = errGroup[type][0]?.ctx?.min_length;
          const max = errGroup[type][0]?.ctx?.max_length;
          const limitVal = min ? `least \`${min}\`` : max ? `most \`${max}\`` : "least `1`";
          const subText = SUB_TEXT_BY_ERROR_TYPE[type] || "";
          errMsgItem += t(`error.${errCode}-content`, {
            field_name: fields,
            file_name: getFileUploadName(fileName),
            detail_msg: descMsg,
            limit_value: limitVal,
            sub_text: subText,
          });
        }
        break;
    }
    outputList.push(errMsgItem);
  }

  return outputList;
};

const useErrorDetails = (errList) => {
  const { t } = useTranslation(["gnc-simulator-6dof", "common"]);
  const errorDetails = useMemo(() => {
    if (Array.isArray(errList)) {
      return errList.map((item) => getErrorDetails(item.errors, item.name, t));
    }
    if (typeof errList === "object" && errList !== null) {
      return getErrorDetails(errList?.errors, errList?.name, t);
    }
    return [];
  }, [errList, t]);
  return errorDetails;
};
export default useErrorDetails;